import * as React from 'react';
import { observer } from 'mobx-react';
import Slider, { SliderProps } from '@mui/material/Slider';

import { DefaultAppProps } from '../App';
import { ViewHeightType } from '../tool/Person';

interface FollowerMarks {
    value: number;
    scaledValue: number;
    label: string;
}

interface HeightSliderProps extends DefaultAppProps {
    disabled?: boolean;
}

const followersMarks: Array<FollowerMarks> = [
    {
    value: 0,
    scaledValue: ViewHeightType.CHILD,
    label: 'Child'
    },
    {
    value: 50,
    scaledValue: ViewHeightType.PARENT,
    label: 'Parent'
    },
    {
    value: 100,
    scaledValue: ViewHeightType.BIRD,
    label: 'Bird'
    }
];

export const HeightSlider: React.FC<HeightSliderProps> = observer((props: HeightSliderProps) => {
    const scale: SliderProps['scale'] = (currentValue: number): number => {
        const previousMarkIndex: number = Math.floor(currentValue / 50);
        const previousMark: FollowerMarks = followersMarks[previousMarkIndex];
        const remainder: number = currentValue % 50;
        if (remainder === 0) {
            return previousMark.scaledValue;
        }
        const nextMark: FollowerMarks = followersMarks[previousMarkIndex + 1];
        const increment: number = (nextMark.scaledValue - previousMark.scaledValue) / 50;
        return remainder * increment + previousMark.scaledValue;
    };

    const handleChange: SliderProps['onChange'] = (event, newValue): void => {
        const currentValue: number = props.app.viewManager.state.currentViewingHeightValue;
        let nextValue: number = Array.isArray(newValue) ? newValue[0] : newValue;
        if (newValue > currentValue && newValue > 44 && newValue < 50) {
            nextValue = 50;
        } else if (currentValue === 50 && newValue > currentValue && newValue <= 56) {
            nextValue = 50;
        } else if (newValue < currentValue && newValue < 56 && newValue > 50) {
            nextValue = 50;
        } else if (currentValue === 50 && newValue < currentValue && newValue >= 44) {
            nextValue = 50;
        }
        props.app.viewManager.setCustomViewerHeight(nextValue, scale(nextValue));
    };

    return (
        <div>
            <Slider
                style={{ width: 200, maxWidth: 500 }}
                value={props.app.viewManager.state.currentViewingHeightValue}
                min={0}
                step={1}
                max={100}
                scale={scale}
                onChange={handleChange}
                valueLabelDisplay="off"
                aria-labelledby="non-linear-slider"
                disabled={props.disabled}
            />
        </div>
    );
});